import React from "react";

import link from '../../assets/images/icon-link.svg';
import './ProviderContactCards.scss'; 
import checkicon from '../../assets/images/icon-checkmark.svg';
import iconclose from '../../assets/images/icon-x-black.svg';

import { ProviderSchedulingEarliestAppointment } from "../../../../VMC.Website/Features/Valley Medical/Blocks/ProviderSchedulingBlock/react/ProviderSchedulingEarliestAppointment";

export const ProviderContactCards = (props) => {
  const { 
    name, 
    title,
    titles, 
    specialties, 
    acceptPatients,
    telehealthOptionsAvailable,
    acceptPatientsOriginal,
    acceptPatientsOriginalBioDisplayText,
    acceptPatientsOriginalSearchDisplayText,
      acceptPatientsOriginalImageURL,
    showAcceptPatients, 
    imageUrl, 
    imageErrorUrl, 
    bioPageUrl, 
    affiliation,
    clinics,
    providerClick,
    myChartProviderID,
    myChartDepartmentID,
    myChartVisitTypeID,
    myChartSchedulingSearchResultsEnabled,
    hideEarliestAppointment
  } = props;

  const allTitles = (titles || []).map(
      (t, i) => <>{i > 0 ? ', ' : ''}<span className='credential-title'>{t}</span></>
    );
  
  const onError = e =>{
    if (imageErrorUrl) {
      e.currentTarget.src = imageErrorUrl;
    } else {
      console.log('imageErrorUrl falsy: is the provider placeholder image set in the CMS?');
    }
  };
  const getAcceptPatients = acceptPatients => {
    if (acceptPatients) {
      if(acceptPatientsOriginal) {
        var image = acceptPatientsOriginalImageURL && <img className="label_icons" src={acceptPatientsOriginalImageURL} alt=""/>;
        return (
            <label className={"labeling_card label_" + acceptPatientsOriginal + (telehealthOptionsAvailable ? " margin_bottom_zero" : "")} htmlFor="Patients">
            {/* If the accepting patient search display is blank then put the image by itself.
            Otherwise put the image on the first line of the search text. */}
            {!acceptPatientsOriginalSearchDisplayText && image}
            {acceptPatientsOriginalSearchDisplayText?.split('\n').map((x, i) => <span>{i==0 && image} {x}</span>)}
            {(
              acceptPatientsOriginal === "YES" && myChartSchedulingSearchResultsEnabled && !hideEarliestAppointment
                ? <ProviderSchedulingEarliestAppointment
                    myChartProviderID={myChartProviderID}
                    myChartDepartmentID={myChartDepartmentID}
                    myChartVisitTypeID={myChartVisitTypeID}
                    />
                : ""
                )}

               
          </label>
        );
      }
        return (
            <label className={"labeling_card label_accept " + (telehealthOptionsAvailable ? " margin_bottom_zero" : "")} htmlFor="Patients">
          <span>
            <img className="label_icons" src={checkicon} alt=""/> Accepting New Patients
            {(
              myChartSchedulingSearchResultsEnabled
                ? <ProviderSchedulingEarliestAppointment
                    myChartProviderID={myChartProviderID}
                    myChartDepartmentID={myChartDepartmentID}
                    myChartVisitTypeID={myChartVisitTypeID}
                    />
                : null
            )}
              </span>

             
        </label>
      );
    } else {
        return (
            <label className={"labeling_card label_close " + (telehealthOptionsAvailable ? " margin_bottom_zero" : "")} htmlFor="Patients">
              <span><img className="label_icons" src={iconclose} alt="" /> Not Accepting New Patients</span>
             
        </label>
      );
    }
  }
  return (
    <a onClick={providerClick} className="provider_contact_card" href={bioPageUrl}>
      <div className="provider_Contact_img_card"><img src={imageUrl} onError={onError} alt={`${name}, ${allTitles}`} /></div>
      <h3>{name}, {allTitles}</h3>
      <div style={{
        fontSize: '1.2rem'
      }}>
        {clinics && clinics.map(clinic => 
          <div>{clinic.name.replace(/\s*-\s*Primary\s*Care\s*$/i,"")}</div>
        )}
      </div>
      <p>{specialties ? specialties.join(', ') : ''}</p>
          {showAcceptPatients && getAcceptPatients(acceptPatients)}

          {(telehealthOptionsAvailable ?
              <label className="labeling_card label_accept telehealth">
                  <span><img className={"label_icons "} src={checkicon} alt="" /> Telehealth Options Available</span>
              </label>
           : "")}
      {affiliation && <p className="cta"> <img className="pcc-icon" src={link} alt=""/>{affiliation}</p>}
    </a>
  );
};